var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMagazineIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.951,
    height: 31.081,
    viewBox: "0 0 29.951 31.081",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 1,
    x2: 1.134,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d20255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#d20255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#f37d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#fbbf02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbbf02"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2028",
    "data-name": "Trac\\xE9 2028",
    d: "M-2073.141,2135.967h-8.145a1.95,1.95,0,0,0-.281.028,1.957,1.957,0,0,0-.281-.028h-8.145a6.557,6.557,0,0,0-6.549,6.551V2160.5a6.557,6.557,0,0,0,6.549,6.551h8.145a1.992,1.992,0,0,0,.281-.028,1.985,1.985,0,0,0,.281.028h8.145a6.558,6.558,0,0,0,6.55-6.551v-17.979A6.558,6.558,0,0,0-2073.141,2135.967Zm-19.4,24.53v-17.979a2.554,2.554,0,0,1,2.549-2.551h1.52a11.5,11.5,0,0,1,8.994,4.318,11.646,11.646,0,0,1,2.259,9.84,11.819,11.819,0,0,1-11.709,8.923h-1.064A2.553,2.553,0,0,1-2092.542,2160.5Zm21.951,0a2.553,2.553,0,0,1-2.55,2.551h-5.033a14.934,14.934,0,0,0,4.862-8.068,15.628,15.628,0,0,0-3.051-13.2,15.727,15.727,0,0,0-1.744-1.811h4.966a2.554,2.554,0,0,1,2.55,2.551Z",
    transform: "translate(2096.542 -2135.967)",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagazineIcon);
export default __webpack_public_path__ + "static/media/magazineIcon.3f4cd91e40772083b71fef9d8c4f90c5.svg";
export { ForwardRef as ReactComponent };